import React from 'react';
import FinancialStatementTable from './FinancialStatementTable';
import {
    buildCashFlowStatementRows,
    isCashFlowSectionCollapsible,
    isCashFlowStatementRowVisible,
} from '../config/cashFlowStatementLayout';

const DEFAULT_EXPANDED = { operating: true, investing: true, financing: true };

const DERIVED_ANALYSIS_NOTE =
    'A fuller sector-aware breakdown of these metrics is available in the Cash Flow Ratios section below.';

function CashFlowStatementTable({ data, orderedKeys = [], headers = [], onMetricInfo, onOpenChart }) {
    return (
        <FinancialStatementTable
            title="Cash Flow Statement"
            data={data}
            orderedKeys={orderedKeys}
            headers={headers}
            onMetricInfo={onMetricInfo}
            onOpenChart={onOpenChart}
            buildRows={buildCashFlowStatementRows}
            isSectionCollapsible={isCashFlowSectionCollapsible}
            isRowVisible={isCashFlowStatementRowVisible}
            defaultExpanded={DEFAULT_EXPANDED}
            statementKey="cashFlow"
            dividerNote={DERIVED_ANALYSIS_NOTE}
        />
    );
}

export default CashFlowStatementTable;
